import React from 'react'

const PDFEmbed = ({ url }) => { 
  return (
    <div>
      <iframe 
        title="PDF"
        allowFullScreen
        allow="fullscreen" 
        style={{ border: 'none', width: '100%', height: '650px' }}
        src={url}>
      </iframe>
    </div>
  )
}

export default PDFEmbed
